<div class="order-return-form" *ngIf="currentParentSalesOrder">
  <mat-card>
    <mat-card-content>
      <form [formGroup]="form">
        <div class="p-5">
          <div class="d-flex justify-content-between">
            <div class="align-self-center">
              <h3 class="mt-4 inline">
                Create Return Order - [Sales Order #
                {{ currentParentSalesOrder.orderNumber }}]
              </h3>
            </div>
            <div class="align-self-center">
              <button
                type="button"
                class="lum-button lum-button--secondary"
                mat-button
                [routerLink]="['/orders/return-orders/', parentSalesOrderId]"
              >
                <lum-ui-icon
                  icon="chevron-left-circle"
                  [width]="24"
                  [height]="24"
                  color="#5563d6"
                ></lum-ui-icon>
                Go Back To Return Orders
              </button>
            </div>
          </div>
          <mat-divider class="my-2"></mat-divider>
        </div>
        <div class="p-5">
          <div class="row mb-4">
            <div class="col-4">
              <label>Return Order Date</label>
              <input
                formControlName="orderReturnDate"
                type="date"
                required="true"
                class="lum-input"
              />
              <mat-error *ngIf="form.get('orderReturnDate')?.invalid">
                {{ form.get('orderReturnDate') | validateField }}
              </mat-error>
            </div>
          </div>
          <div class="row mb-4">
            <div class="col-4">
              <mat-checkbox
                color="primary"
                (change)="onCheckChangeReStock($event)"
                formControlName="restock"
              >
                Re-stock
              </mat-checkbox>
            </div>
          </div>
          <div class="order-return-form-table__wrapper">
            <table class="lum-table lum-table--classic striped">
              <tr class="table__head-row">
                <th style="width: 180px">SKU/Name</th>
                <th style="width: 180px">Description</th>
                <th>Quantity</th>
                <th>Unit</th>
                <th>Returnable Quantity</th>
                <th>Base Quantity</th>
                <th></th>
                <th *ngIf="isRestock">Location</th>
                <th *ngIf="isRestock">Lot</th>
                <th class="text-end" style="width: 180px">Unit Price</th>
                <th class="text-end" style="width: 10%">Line Total</th>
              </tr>
              <tbody>
                <ng-container formArrayName="orderReturnItems">
                  <tr
                    *ngFor="let row of items?.controls; let idx = index"
                    [formGroupName]="idx"
                  >
                    <td>
                      <span>
                        <strong>[{{ row.value.sku }}]</strong>
                        {{ row.value.name }}
                        <mat-chip
                          class="
                            lum-chip border-transparent text-cloud-900 bg-cloud-300 hover:cloud-400 active:cloud-500 focus:cloud-400 lum-chip--small
                          "
                          >{{ row.value?.itemType }}</mat-chip
                        >
                      </span>
                    </td>
                    <td>
                      <span>{{ row.value.productDescription }}</span>
                    </td>
                    <td>
                      <input
                        formControlName="quantity"
                        [value]="row.value.quantity"
                        type="number"
                        required="true"
                        class="lum-input w-30"
                        placeholder="Quantity"
                        (input)="onChangeQuantityEvent(idx)"
                      />
                      <mat-error *ngIf="row.get('quantity')?.invalid">
                        {{ row.get('quantity') | validateField }}
                      </mat-error>
                    </td>
                    <td>
                      <lum-ui-advance-select
                        placeholder="Select"
                        [items]="formattedUnitOfMeasures"
                        [disabled]="row.value?.itemType === eItemType.KIT"
                        [loading]="(loadingUnitOfMeasures$ | async) || false"
                        [selectedOption]="row?.value?.selectedUnitOfMeasure"
                        (openedChange)="onOpenUnitOfMeasureListEvent(idx)"
                        (selectOptionEvent)="
                          onSelectUnitOfMeasureEvent($event, idx)
                        "
                      ></lum-ui-advance-select>
                      <mat-error *ngIf="row.get('uomId')?.invalid">
                        {{ row.get('uomId') | validateField }}
                      </mat-error>
                    </td>
                    <td>
                      <span
                        >{{ row.value?.availableQuantity
                        }}<i class="text-cloud-500">{{
                          row.value?.selectedUnitOfMeasure?.label
                        }}</i></span
                      >
                    </td>
                    <td>
                      <span
                        >{{ row.value?.orderedQuantity
                        }}<i class="text-cloud-500">{{
                          row.value?.selectedBaseUnitOfMeasure?.label
                        }}</i></span
                      >
                    </td>
                    <td>
                      <ul class="list-unstyled">
                        <li>
                          <mat-chip
                            class="
                              lum-chip border-transparent text-cloud-900 bg-cloud-300 hover:cloud-400 active:cloud-500 focus:cloud-400 lum-chip--small
                            "
                            >Ordered -
                            {{
                              row.value?.quantityOrdered | decimalPlaces
                            }}</mat-chip
                          >
                        </li>
                        <li>
                          <mat-chip
                            class="
                              lum-chip border-transparent text-cloud-900 bg-cloud-300 hover:cloud-400 active:cloud-500 focus:cloud-400 lum-chip--small
                            "
                            >Cancelled -
                            {{
                              row.value?.quantityCancelled | decimalPlaces
                            }}</mat-chip
                          >
                        </li>
                        <li>
                          <mat-chip
                            class="
                              lum-chip border-transparent text-cloud-900 bg-cloud-300 hover:cloud-400 active:cloud-500 focus:cloud-400 lum-chip--small
                            "
                            >Shipped -
                            {{
                              row.value?.quantityShipped | decimalPlaces
                            }}</mat-chip
                          >
                        </li>
                        <li>
                          <mat-chip
                            class="
                              lum-chip border-transparent text-cloud-900 bg-cloud-300 hover:cloud-400 active:cloud-500 focus:cloud-400 lum-chip--small
                            "
                            >Returned -
                            {{
                              row.value?.quantityReturned | decimalPlaces
                            }}</mat-chip
                          >
                        </li>
                      </ul>
                    </td>
                    <td *ngIf="isRestock">
                      <lum-ui-advance-select
                        placeholder="Select"
                        [items]="formattedLocations"
                        [loading]="(loadingLocations$ | async) || false"
                        [selectedOption]="row?.value?.selectedLocation"
                        (openedChange)="onOpenLocationListEvent(idx)"
                        (selectOptionEvent)="onSelectLocationEvent($event, idx)"
                      ></lum-ui-advance-select>
                      <mat-error *ngIf="row.get('locationId')?.invalid">
                        {{ row.get('locationId') | validateField }}
                      </mat-error>
                    </td>
                    <td *ngIf="isRestock">
                      <lum-ui-advance-select
                        [disabled]="!row.value?.hasLotTracking"
                        placeholder="Select"
                        [items]="formattedLots"
                        [loading]="(loadingLots$ | async) || false"
                        [selectedOption]="row?.value?.selectedLot"
                        (openedChange)="onOpenLotListEvent(idx)"
                        (selectOptionEvent)="onSelectLotEvent($event, idx)"
                      ></lum-ui-advance-select>
                      <mat-error *ngIf="row.get('lotId')?.invalid">
                        {{ row.get('lotId') | validateField }}
                      </mat-error>
                    </td>
                    <td class="text-end">
                      <input
                        [value]="
                          (
                            row.value.baseUnitPrice * row.value.baseQuantity
                          ).toFixed(2)
                        "
                        type="text"
                        class="lum-input"
                        placeholder="Unit Price"
                        [readonly]="true"
                      />
                    </td>
                    <td class="text-end">
                      <input
                        [value]="
                          (
                            +(
                              row.value.baseUnitPrice * row.value.baseQuantity
                            ).toFixed(2) * row.value.quantity
                          ).toFixed(2)
                        "
                        type="text"
                        class="lum-input"
                        placeholder="Unit Price"
                        [readonly]="true"
                      />
                    </td>
                  </tr>
                </ng-container>
                <tr class="border-0">
                  <td [attr.colspan]="isRestock ? 9 : 7"></td>
                  <td class="text-end">
                    <span class="text-cloud-500">Item Subtotal Refund:</span>
                  </td>
                  <td class="text-end">
                    <strong>{{ itemSubtotalRefund | currency }}</strong>
                  </td>
                </tr>
                <tr class="border-0">
                  <td [attr.colspan]="isRestock ? 9 : 7"></td>
                  <td class="text-end">
                    <span class="text-cloud-500">Custom Refund Amount:</span>
                  </td>
                  <td class="text-end">
                    <input
                      formControlName="customRefundAmount"
                      [value]="form.value.customRefundAmount"
                      type="number"
                      class="lum-input"
                      placeholder="Custom Refund Amount"
                    />
                  </td>
                </tr>
                <tr class="border-0">
                  <td [attr.colspan]="isRestock ? 9 : 7"></td>
                  <td class="text-end">
                    <span class="text-cloud-500">Re-stocking Fee:</span>
                  </td>
                  <td class="text-end">
                    <input
                      formControlName="restockingFee"
                      [value]="form.value.restockingFee"
                      type="number"
                      class="lum-input"
                      placeholder="Re-stocking Fee"
                    />
                  </td>
                </tr>
                <tr class="border-0">
                  <td [attr.colspan]="isRestock ? 9 : 7"></td>
                  <td class="text-end">
                    <span class="text-cloud-500">Grand Total Refund:</span>
                  </td>
                  <td class="text-end">
                    <strong>{{ grandTotalRefund | currency }}</strong>
                  </td>
                </tr>
                <tr class="border-0">
                  <td [attr.colspan]="isRestock ? 9 : 7"></td>
                  <td class="text-end">
                    <span class="text-cloud-500">Refund Item Quantity:</span>
                  </td>
                  <td class="text-end">
                    <strong>{{ refundItemQuantity }}</strong>
                  </td>
                </tr>
                <tr class="border-0">
                  <td [attr.colspan]="isRestock ? 9 : 7"></td>
                  <td class="text-end">
                    <span class="text-cloud-500">Order Total:</span>
                  </td>
                  <td class="text-end">
                    <strong>{{ orderTotal | currency }}</strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="d-flex justify-content-end">
            <lum-ui-button
              [loading]="(submittingForm$ | async) || false"
              (clickEvent)="onSubmit()"
            >
              Submit Return Order
              <lum-ui-icon class="ml-2-5" icon="content-save"></lum-ui-icon>
            </lum-ui-button>
          </div>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>
